import {
  Button,
  Checkbox,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
} from '@material-ui/core';
import { MoreHoriz, AddCircle, RemoveCircle, DragIndicator } from '@material-ui/icons';
import CreateIcon from '@material-ui/icons/Create';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import VisibilityIcon from '@mui/icons-material/Visibility';
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_HOTEL_SPA,
} from '../../../../../constants/RoleConsts';
import {
  TREATMENTS_CREATE,
  TREATMENTS_EDIT,
  TREATMENTS_VIEW,
  TREATMENT_FILTER_DATA,
  TREATMENT_FILTER_DATA_TYPE,
} from '../../../../../constants/SpaConst';
import DeletePopupModel from '../../../../../shared/delete-popup/Delete-Popup';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';
import SearchBar from '../../../../../shared/search-bar/Search-Bar';
import TablePaginationActions from '../../../../../shared/table-pagination/TablePaginationActions';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import {
  changeTreatmentInfoStatus,
  createDataSortMapping,
  deleteSpaTreatmentAPI,
} from '../../../../../utils/PropertyAPIUtils';
import {
  allSpaCategoriesSelector,
  allSpaInfoSelector,
  allSpaTreatmentsSelector,
  fetchAllSpa,
  setAllSpaTreatments,
} from '../../../../property/propertySlice';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import useOutsideAlerter from '../../../../../custom-hooks/useOutsideAlerter';
import { handleOnDragEnd } from '../../../../../shared/custom-dragdrop/dragDrop';
import MultipleDeleteConfirmationPopup from '../../../../../shared/MultiActionPopUp/MultiDeleteConfirmationPopup';
import {
  deleteSelectedItems,
  updateSelectedItemsStatus,
} from '../../../../../utils/ServicesAPIUtils';
import {
  PARTIAL_CHECKBOX_GREEN,
  ResetFilterList,
  getCheckedIds,
  isDragDisabled,
  updateCheckedStatus,
  updateSelectedModule,
} from '../../../../../utils/formUtils';
import { generateConfirmationMessage } from '../../../../../utils/formUtils';
import MultipleSelectionAlert from '../../../../../shared/MultiActionPopUp/MultipleSelectionAlert';
import BulkActionCheckBox from '../../../../../shared/MultiActionPopUp/BulkActionCheckBox';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const TreatmentsList = (props) => {
  const {
    onDrawerToggle,
    onViewToggle,
    selectedHotel,
    permissions,
    page,
    rowsPerPage,
    onsetRowsPerPage,
    onsetPage,
  } = props;
  const dispatch = useDispatch();
  const [selectedValue, setSelectedValue] = useState({
    id: '',
    name: '',
    title: '',
    description: '',
    status: false,
    anchorEl: null,
    spaTreatment: null,
  });
  const originalSpaInfo = useSelector(allSpaInfoSelector);
  const originalSpaCategory = useSelector(allSpaCategoriesSelector);
  const originalSpaTreatments = useSelector(allSpaTreatmentsSelector);
  const [spaTreatments, setSpaTreatments] = useState([]);
  const [filteredBaseList, setFilteredBaseList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterDataList, setFilterDataList] = useState([]);
  const [popUp, setPopUp] = useState(false);
  const [visible, setVisible] = useState(false);
  const wrapperRef = useRef(null);
  const prevHotelIdRef = useRef(selectedHotel);
  const [searchText, setSearchText] = useState('');
  const [showMultipleDeleteConfirmation, setShowMultipleDeleteConfirmation] = useState(false);
  const [actionName, setActionName] = useState(false);
  const [showBulkActiveDeactiveConfirmation, setShowBulkActiveDeactiveConfirmation] =
    useState(false);
  const [showBulkKebabSelectionAlert, setShowBulkKebabSelectionAlert] = useState(false);
  const [actionMenuList, setActionMenuList] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const isFilterApplied = useRef(false);
  const checkedSpaTreatment = spaTreatments?.filter((sTreatment) => sTreatment?.isChecked);

  const selectedCheckedTreatmentLength = checkedSpaTreatment?.length;
  const listOfSpaTreatmentIds = checkedSpaTreatment?.map((SpaTreatment) => SpaTreatment?.id);
  const [dragEnabled, setDragEnabled] = useState(true);

  useEffect(() => {
    setFilterDataList(TREATMENT_FILTER_DATA);
  }, []);

  useEffect(() => {
    setSearchText('');
    setFilteredBaseList(originalSpaTreatments);
    setSpaTreatments((prevList) => {
      return originalSpaTreatments?.map((spaTreatment) => {
        return {
          ...spaTreatment,
        };
      });
    });
    setLoading(false);
  }, [originalSpaInfo, originalSpaTreatments, originalSpaCategory]);

  const handleSearchText = (searchText) => {
    setSearchText(searchText);
    const checkedIdList = getCheckedIds(spaTreatments, 'isChecked');
    const filteredRows = filteredBaseList.filter((item) =>
      item.name?.toLowerCase().includes(searchText.toLowerCase()),
    );
    const updatedCheckedList = updateCheckedStatus(filteredRows, checkedIdList);
    onsetPage(0);
    setSpaTreatments(updatedCheckedList);
  };

  useEffect(() => {
    updateSelectedModule(spaTreatments, setActionMenuList, setIsAllSelected);
  }, [spaTreatments]);

  const resetFilterDataList = () => {
    TREATMENT_FILTER_DATA[3].subMenu = TREATMENT_FILTER_DATA_TYPE;
    if (originalSpaInfo && originalSpaInfo?.length > 0) {
      TREATMENT_FILTER_DATA[2].subMenu = originalSpaInfo?.map((value) => {
        return { id: value?.id, name: value?.name, selected: false };
      });
      if (originalSpaCategory && originalSpaCategory?.length > 0) {
        TREATMENT_FILTER_DATA[1].subMenu = originalSpaCategory?.map((value) => ({
          id: value?.id,
          name: value?.name,
          selected: false,
        }));
      } else {
        TREATMENT_FILTER_DATA[1].subMenu = [];
      }
      setFilterDataList([...TREATMENT_FILTER_DATA]);
    }
  };

  useEffect(() => {
    resetFilterDataList();
  }, [originalSpaInfo, originalSpaTreatments, originalSpaCategory]);

  useEffect(() => {
    if (loading || spaTreatments?.length === 0) return;
    const totalItems = spaTreatments?.length;
    const maxPageIndex = Math.max(Math.ceil(totalItems / rowsPerPage) - 1, 0);
    if (page > maxPageIndex) {
      onsetPage(maxPageIndex);
    }
  }, [spaTreatments?.length, rowsPerPage, page, onsetPage]);

  useEffect(() => {
    if (prevHotelIdRef?.current !== selectedHotel) {
      onsetPage(0);
    }
    prevHotelIdRef.current = selectedHotel;
  }, [selectedHotel]);

  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event.target.value, 10));
    onsetPage(0);
  };

  const onOpenDrawer = (event, type) => {
    if (selectedCheckedTreatmentLength) {
      setSpaTreatments(ResetFilterList);
    }
    event.stopPropagation();
    onDrawerToggle(type, true, selectedValue.spaTreatment);
    handleClose();
  };

  const handleClose = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      spaTreatment: null,
    });
  };

  const handleCellMenuClick = (event, spaTreatmentItem) => {
    event.stopPropagation();
    if (selectedCheckedTreatmentLength > 1) {
      setShowBulkKebabSelectionAlert(true);
    } else {
      setSelectedValue({
        id: spaTreatmentItem.id,
        name: spaTreatmentItem.name,
        title: '',
        description: '',
        status: false,
        anchorEl: event.currentTarget,
        spaTreatment: spaTreatmentItem,
      });
    }
  };

  const deleteSpaTreatment = async (e) => {
    e.preventDefault();
    setSelectedValue((prev) => ({
      ...prev,
      title: 'Are you sure you want to delete',
      description: 'This action cannot be reversed',
      status: true,
      anchorEl: null,
    }));
  };

  const deleteSpaTreatmentAPICall = async () => {
    try {
      const lang = decryptLocalStorage('lang');
      const delByLang = lang !== 'en' ? lang : '';
      if (selectedHotel && selectedValue && selectedValue.id) {
        await deleteSpaTreatmentAPI(selectedValue.id, selectedHotel, delByLang);
        dispatch(fetchAllSpa(selectedHotel));
        notificationManager('success', 'Treatment deleted successfully');
      }
      handleClose();
    } catch (e) {
      if (e.graphQLErrors) {
        notificationManager('danger', e.graphQLErrors[0].message);
      } else {
        notificationManager('danger', 'Failed to delete Treatment');
      }
      handleClose();
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const onDeleteCancel = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      spaTreatment: null,
    });
  };

  const onViewDetails = (treatmentItem, e) => {
    if (e?.target?.tagName === 'TD') {
      onViewToggle(TREATMENTS_VIEW, true, treatmentItem);
    }
  };

  const onClickView = (e) => {
    if (selectedValue && selectedValue.spaTreatment) {
      onViewToggle(TREATMENTS_VIEW, true, selectedValue.spaTreatment);
    }
  };

  const retriveSpaName = (spaTreatmentItem) => {
    if (originalSpaInfo && originalSpaInfo.length > 0) {
      const spaNameArray = originalSpaInfo.filter(
        (spaInfoItem) => spaInfoItem.id === spaTreatmentItem.spaId,
      );
      return spaNameArray.length > 0 ? spaNameArray[0].name : false;
    }
  };

  const retriveCategoryName = (spaTreatmentItem) => {
    if (originalSpaCategory && originalSpaCategory.length > 0) {
      const categoryNameArray = originalSpaCategory?.filter(
        (categoryItem) => categoryItem.id === spaTreatmentItem.spaCategoryId,
      );
      return categoryNameArray.length > 0 ? categoryNameArray[0].name : false;
    }
  };

  const retrivePaxType = (type) => {
    const paxType = TREATMENT_FILTER_DATA_TYPE.filter((SpaTreatment) => SpaTreatment.id === type);
    return paxType.length > 0 ? paxType[0].name : false;
  };

  const filteredRecords = (filters, field) => {
    if (field === 'all') {
      setFilteredBaseList(originalSpaTreatments);
      setSpaTreatments(originalSpaTreatments);
      resetFilterDataList();
      isFilterApplied.current = false;
    } else {
      isFilterApplied.current = true;
      const filterIdWithFields = filterDataList
        .filter((initialFilter) => initialFilter.subMenu.length > 0)
        .map((filterItem) => {
          const subMenuFiltersId = filterItem.subMenu
            .filter((fItem) => fItem.selected === true)
            .map((fItemId) => fItemId.id);
          if (subMenuFiltersId.length > 0) {
            return {
              id: subMenuFiltersId,
              field: filterItem.field,
            };
          } else return null;
        })
        .filter((SpaTreatment) => SpaTreatment !== null);
      const filteredRecords = originalSpaTreatments?.filter((treatment) => {
        const doesFilterSatisfy = filterIdWithFields.map((filter) =>
          filter.id.includes(treatment[filter.field]),
        );
        return !doesFilterSatisfy.includes(false);
      });
      onsetPage(0);
      setFilteredBaseList(filteredRecords);
      setSpaTreatments(filteredRecords);
    }
  };

  const onChangeStatus = async (e, payload) => {
    e.stopPropagation();
    const lang = decryptLocalStorage('lang');
    const selectedLang = lang !== 'en' ? lang : '';
    try {
      const item = { ...payload };
      item.isActive = !payload.isActive;

      await changeTreatmentInfoStatus(selectedHotel, item.id, item.isActive, selectedLang);
      notificationManager(
        'success',
        item.isActive ? 'Treatment activated successfully' : 'Treatment deactivated successfully',
      );
      dispatch(fetchAllSpa(selectedHotel));
    } catch (e) {
      if (e.graphQLErrors) {
        notificationManager('danger', e.graphQLErrors[0].message);
      } else {
        notificationManager('danger', 'Failed');
      }
    }
    handleClose(e);
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  useOutsideAlerter(wrapperRef, visible, setPopUp);

  const handleAction = (actionName) => {
    let selectedValue = spaTreatments?.filter((feed) => feed?.isChecked);
    switch (actionName) {
      case 'Delete':
        if (selectedValue?.length > 0) {
          setShowMultipleDeleteConfirmation(true);
          setActionName('delete');
        }
        break;
      case 'Activate':
        if (selectedValue?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('activate');
          setIsActive(true);
        }
        break;
      case 'Deactivate':
        if (selectedValue?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('deactivate');
          setIsActive(false);
        }
        break;
      default:
        break;
    }
  };

  const handleSelectAll = (event) => {
    let selectedTreatmentList = [];
    let actionListName = [];
    const CheckedValue = event?.target?.checked;
    setIsAllSelected(CheckedValue);
    selectedTreatmentList = spaTreatments?.map((SpaTreatment) => {
      return {
        ...SpaTreatment,
        isChecked: CheckedValue,
      };
    });

    const isActive = selectedTreatmentList?.some((treatment) => treatment?.isActive);
    const isInactive = selectedTreatmentList?.some((treatment) => !treatment.isActive);

    if (isActive && !actionListName?.includes('Deactivate')) {
      actionListName.push('Deactivate');
    }
    if (isInactive && !actionListName?.includes('Activate')) {
      actionListName.push('Activate');
    }

    setSpaTreatments([...selectedTreatmentList]);

    const sortActionMenuList = actionListName.sort((a, b) => {
      const order = { Activate: 1, Deactivate: 2 };
      return order[a] - order[b];
    });

    setActionMenuList(sortActionMenuList);

    if (
      !event?.target?.checked &&
      !selectedTreatmentList?.some((SpaTreatment) => SpaTreatment?.isChecked)
    ) {
      setActionMenuList([]);
    }
  };

  const handleCheckboxChange = (id) => {
    let actionListName = [];
    let actionList = [];
    let index = spaTreatments?.findIndex((SpaTreatment) => SpaTreatment.id === id);
    if (!spaTreatments[index]?.isChecked) {
      spaTreatments[index] = { ...spaTreatments[index], isChecked: true };
    } else {
      spaTreatments[index].isChecked = !spaTreatments[index]?.isChecked;
    }
    setSpaTreatments([...spaTreatments]);

    actionList = spaTreatments
      ?.filter((sInfo) => sInfo?.isChecked)
      .map((status) => status?.isActive);

    const checkedItems = spaTreatments?.filter((discount) => discount?.isChecked);

    if (checkedItems.length === 0) {
      setActionMenuList([]);
      setIsAllSelected(false);
      return;
    }

    const isActiveSelected = actionList.includes(true);
    const isInactiveSelected = actionList.includes(false);

    if (isActiveSelected && isInactiveSelected) {
      actionListName.push('Activate', 'Deactivate');
    } else if (isActiveSelected) {
      actionListName.push('Deactivate');
    } else if (isInactiveSelected) {
      actionListName.push('Activate');
    }

    const isAllSelected = spaTreatments?.every((SpaTreatment) => SpaTreatment?.isChecked);
    setIsAllSelected(isAllSelected);

    setActionMenuList(actionListName);
  };

  const onApiCallConfirmationNotification = generateConfirmationMessage(
    'Treatment',
    listOfSpaTreatmentIds?.length,
    isActive,
  );

  const handleMultipleStatusChange = async () => {
    handleClose();
    setActionMenuList([]);
    try {
      dispatch(stepUpLoaderCount());
      setLoading(true);
      const filterApplied = searchText?.length > 0 || isFilterApplied?.current ? true : false;
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'SPA_TREATMENTS';
      await updateSelectedItemsStatus(
        listOfSpaTreatmentIds,
        selectedHotel,
        selectedLang,
        moduleName,
        '',
        isActive,
        filterApplied ? false : isAllSelected,
      );
      dispatch(fetchAllSpa(selectedHotel));
      notificationManager('success', onApiCallConfirmationNotification);
      setLoading(false);
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors
          ? e.graphQLErrors[0].message
          : 'The status of the Treatment was not changed',
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }

    setIsAllSelected(false);
    setSpaTreatments(ResetFilterList);
  };

  const deleteMultipleSelections = async () => {
    handleClose();
    try {
      setLoading(true);
      const filterApplied = searchText.length > 0 || isFilterApplied?.current ? true : false;
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'SPA_TREATMENTS';
      await deleteSelectedItems(
        listOfSpaTreatmentIds,
        selectedHotel,
        selectedLang,
        moduleName,
        '',
        filterApplied ? false : isAllSelected,
      );
      dispatch(fetchAllSpa(selectedHotel));
      notificationManager('success', 'Treatments deleted successfully');
      setLoading(false);
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : 'Failed to delete Treatment',
      );
    }
    setIsAllSelected(false);
    setSpaTreatments(ResetFilterList);
    setActionMenuList([]);
  };

  const dragDisabled = !dragEnabled || spaTreatments?.length <= 1;

  return (
    <div className='mt-4 mb-4 group-list-container'>
      {selectedValue.id && selectedValue.status === true && (
        <DeletePopupModel
          deletePopUp={selectedValue}
          onDelete={deleteSpaTreatmentAPICall}
          onDeleteCancel={onDeleteCancel}
        />
      )}
      {showMultipleDeleteConfirmation && (
        <MultipleDeleteConfirmationPopup
          title={`Are you sure you want to ${actionName} this selection?`}
          subTitle={`A selection of ${selectedCheckedTreatmentLength} ${
            selectedCheckedTreatmentLength > 1 ? 'treatments' : 'treatment'
          } will be ${actionName}d. This Action is irreversible.`}
          isOpen={showMultipleDeleteConfirmation}
          onClose={() => setShowMultipleDeleteConfirmation(false)}
          onConfirm={() => {
            deleteMultipleSelections();
          }}
          leftButtonName={'Cancel'}
          rightButtonName={'Delete'}
        />
      )}

      {showBulkActiveDeactiveConfirmation && (
        <MultipleDeleteConfirmationPopup
          title={`Are you sure you want to ${actionName} this selection?`}
          subTitle={`A selection of ${selectedCheckedTreatmentLength}  ${
            selectedCheckedTreatmentLength > 1 ? 'treatments' : 'treatment'
          } will be ${actionName}d.`}
          isOpen={showBulkActiveDeactiveConfirmation}
          onClose={() => setShowBulkActiveDeactiveConfirmation(false)}
          onConfirm={() => {
            handleMultipleStatusChange();
          }}
          leftButtonName={'No'}
          rightButtonName={'Yes'}
        />
      )}
      <SearchBar
        type={TREATMENTS_CREATE}
        buttonName='Add Treatment'
        displayAddOrEdit={
          permissions[RBAC_TYPE_HOTEL_SPA] === RBAC_PERMISSION_LEVEL_FULL_ACCESS ? 'show' : 'hide'
        }
        onOpenDrawer={onOpenDrawer}
        setSearchText={handleSearchText}
        filterList={filterDataList}
        setFilterDataList={setFilterDataList}
        filteredRecoard={filteredRecords}
        visible={visible}
        setVisible={setVisible}
        popUp={popUp}
        setPopUp={setPopUp}
        placeHolder={spaTreatments}
        setPlaceHolder={setSpaTreatments}
        globalPlaceHolder={originalSpaTreatments}
        setGlobalPlaceHolder={setAllSpaTreatments}
        dispatch={dispatch}
        mappingApi={createDataSortMapping}
        displayText='Spa treatments'
        module='SPA_TREATMENTS'
        searchText={searchText}
        setSearch={setSearchText}
        actionMenuItems={actionMenuList ?? []}
        handleAction={handleAction ?? false}
        setDrag={setDragEnabled}
      />
      <div ref={wrapperRef} className='row mx-2 d-flex mt-4'>
        {loading ? (
          <div className='pt-4 col-md-12'>
            <LinearProgressBar />
          </div>
        ) : (
          spaTreatments && (
            <TableContainer>
              <Table className='list-table' aria-label='simple table'>
                <TableHead>
                  <TableRow>
                    <TableCell className={`w-5 ${dragDisabled ? '' : 'ps-5'}`}>
                      <BulkActionCheckBox
                        onChange={handleSelectAll}
                        checked={isAllSelected || false}
                        selectedLength={selectedCheckedTreatmentLength}
                        totalLength={originalSpaTreatments?.length}
                        inputProps={{
                          'aria-label': 'select all Spa treatments',
                        }}
                        className={PARTIAL_CHECKBOX_GREEN}
                      />
                    </TableCell>
                    <TableCell className='w-30'>Name</TableCell>
                    <TableCell className='w-20'>Spa</TableCell>
                    <TableCell className='w-20'>Category</TableCell>
                    <TableCell className='w-20'>Pax</TableCell>
                    <TableCell className='w-10 text-center'>Status</TableCell>
                    <TableCell align='right'></TableCell>
                  </TableRow>
                </TableHead>
                <DragDropContext
                  onDragEnd={(event) =>
                    handleOnDragEnd(
                      event,
                      setVisible,
                      spaTreatments,
                      setSpaTreatments,
                      false,
                      page,
                      rowsPerPage,
                    )
                  }
                  isDropDisabled={dragDisabled}
                >
                  <Droppable droppableId='spas' isDropDisabled={dragDisabled}>
                    {(provided) => (
                      <TableBody {...provided.droppableProps} ref={provided.innerRef}>
                        {(rowsPerPage > 0
                          ? spaTreatments.slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage,
                            )
                          : spaTreatments
                        ).map((spaTreatmentItem, i) => (
                          <Draggable
                            key={spaTreatmentItem.id}
                            draggableId={spaTreatmentItem.id}
                            index={i}
                            isDragDisabled={dragDisabled}
                          >
                            {(provided) => (
                              <TableRow
                                key={i}
                                className='border-white pointer'
                                onClick={(e) => {
                                  onViewDetails(spaTreatmentItem, e);
                                }}
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <TableCell className='w-12'>
                                  {!dragDisabled && (
                                    <span style={{ marginRight: 1.5 }}>
                                      <DragIndicator className='res-menu-accordion-drag' />
                                    </span>
                                  )}
                                  <Checkbox
                                    onChange={(event) => handleCheckboxChange(spaTreatmentItem?.id)}
                                    checked={spaTreatmentItem?.isChecked ?? false}
                                    inputProps={{
                                      'aria-label': `select spaTreatmentItem ${spaTreatmentItem?.id}`,
                                    }}
                                  />
                                </TableCell>
                                <TableCell className='w-30'>{spaTreatmentItem?.name}</TableCell>
                                <TableCell className='w-20'>
                                  {retriveSpaName(spaTreatmentItem)
                                    ? retriveSpaName(spaTreatmentItem)
                                    : '---'}
                                </TableCell>
                                <TableCell className='w-20'>
                                  {retriveCategoryName(spaTreatmentItem)
                                    ? retriveCategoryName(spaTreatmentItem)
                                    : '---'}
                                </TableCell>
                                <TableCell className='w-20'>
                                  {retrivePaxType(spaTreatmentItem?.type)
                                    ? retrivePaxType(spaTreatmentItem?.type)
                                    : '---'}
                                </TableCell>
                                <TableCell className='w-10 text-center'>
                                  <div className='d-flex justify-content-center'>
                                    <div
                                      className={`pill d-flex justify-content-center align-items-center ${
                                        spaTreatmentItem?.isActive
                                          ? 'pill-active'
                                          : 'pill-inactive theme-dark-green'
                                      }`}
                                    >
                                      <span className='ms-1'>
                                        {spaTreatmentItem?.isActive ? 'Active' : 'Inactive'}
                                      </span>
                                    </div>
                                  </div>
                                </TableCell>
                                <TableCell align='right'>
                                  {permissions[RBAC_TYPE_HOTEL_SPA] ===
                                    RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
                                    <Button
                                      aria-controls='simple-menu'
                                      aria-haspopup='true'
                                      onClick={(e) => {
                                        handleCellMenuClick(e, spaTreatmentItem);
                                      }}
                                      className='showpopupInner'
                                    >
                                      <MoreHoriz className='showpopupInner' />
                                    </Button>
                                  )}
                                  <Menu
                                    id={i}
                                    anchorEl={selectedValue?.anchorEl}
                                    disableRestoreFocus
                                    MenuListProps={{ autoFocusItem: false }}
                                    keepMounted
                                    open={
                                      Boolean(selectedValue.anchorEl) &&
                                      selectedValue.id === spaTreatmentItem.id
                                    }
                                    onClose={handleClose}
                                    className='shadow'
                                  >
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        onChangeStatus(e, selectedValue?.spaTreatment);
                                      }}
                                    >
                                      {selectedValue?.spaTreatment?.isActive === true ? (
                                        <>
                                          <RemoveCircle className='me-2 action-menu-icon' />
                                          Deactivate
                                        </>
                                      ) : (
                                        <>
                                          <AddCircle className='me-2 action-menu-icon' />
                                          Activate
                                        </>
                                      )}
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        onOpenDrawer(e, TREATMENTS_EDIT);
                                      }}
                                    >
                                      <CreateIcon className='me-2 action-menu-icon' />
                                      Edit
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        onClickView(e);
                                      }}
                                    >
                                      <VisibilityIcon className='me-2 action-menu-icon' />
                                      View
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        deleteSpaTreatment(e);
                                      }}
                                    >
                                      <DeleteForeverIcon className='me-2 action-menu-icon' />
                                      Delete
                                    </MenuItem>
                                  </Menu>
                                </TableCell>
                              </TableRow>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </TableBody>
                    )}
                  </Droppable>
                </DragDropContext>
                <TableFooter>
                  <TableRow className='paginator'>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                      count={spaTreatments.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      SelectProps={{
                        inputProps: { 'aria-label': 'rows per page' },
                        native: true,
                      }}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          )
        )}
        {showBulkKebabSelectionAlert && (
          <MultipleSelectionAlert
            isOpen={showBulkKebabSelectionAlert}
            onClose={() => setShowBulkKebabSelectionAlert(false)}
            message='Please select one item from the list that you want to edit.'
            centerButtonName='OK'
          />
        )}
      </div>
    </div>
  );
};

export default TreatmentsList;
